import { Box, Grid, Typography } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { usePqrForm } from './hook';
import { PqrCallInfo } from './callInfo';
import { PqrData } from './data';
import { PqrDataSfc } from './dataSfc';
import { PqrInitialCausality } from './initialCausality';
import { PqrNotificationClient } from './notificationClient';
import { PqrInfo } from './info';
import { PqrReconsideration } from './reconsideration';
import { PqrProductData } from './productData';
import { PqrStrategicAlly } from './strategicAlly';
import { PqrAttachment } from './attachment';
import FormView from '../../../../components/views/formView';
import { PqrFormProps } from './props';
import { Dialog } from '../../../../components/general/dialog/dialog';
import Loading from '../../../../components/general/loadings/loading';

export const PqrForm = ({ showFormView }: PqrFormProps) => {
    const {
        pqr,
        idAccount,
        loading,
        handleSubmit,
        handleClean,
        setFormikPqrCallInfo,
        setFormikPqrData,
        formikPqrData,
        setFormikPqrDataSfc,
        setFormikPqrInitialCausality,
        setFormikPqrNotificationClient,
        setFormikPqrInfo,
        setFormikPqrReconsideration,
        setFormikPqrProductData,
        setFormikPqrStrategicAlly,
        setAttachments,
        isOpenErrorSFCModal,
        setIsOpenErrorSFCModal,
        responseSmart,
    } = usePqrForm();

    return (
        <>
            {showFormView && (
                <FormView title={pqr && pqr.id ? 'Editar PQR' : 'Crear PQR'} />
            )}
            <PqrCallInfo
                data={pqr?.callInfo}
                onChangeFormik={(formik) => setFormikPqrCallInfo(formik)}
            />
            <PqrData
                data={pqr?.data}
                onChangeFormik={(formik) => setFormikPqrData(formik)}
            />
            <PqrDataSfc
                data={pqr?.dataSfc}
                onChangeFormik={(formik) => setFormikPqrDataSfc(formik)}
                receptionChannel={
                    formikPqrData?.values?.receptionChannel as string
                }
                half={formikPqrData?.values?.half as string}
                type={formikPqrData?.values?.type as string}
            />
            <PqrInitialCausality
                data={pqr?.initialCausality}
                onChangeFormik={(formik) =>
                    setFormikPqrInitialCausality(formik)
                }
                typePqr={formikPqrData?.values.type as string}
            />
            <PqrNotificationClient
                data={pqr?.notificationClients}
                onChangeFormik={(formik) =>
                    setFormikPqrNotificationClient(formik)
                }
                idAccount={pqr?.id || idAccount}
            />
            <PqrInfo
                data={pqr?.info}
                onChangeFormik={(formik) => setFormikPqrInfo(formik)}
            />
            <PqrAttachment
                onChangeData={setAttachments}
                data={pqr?.attachments}
            />
            <PqrReconsideration
                data={pqr?.reconsideration}
                onChangeFormik={(formik) => setFormikPqrReconsideration(formik)}
            />
            <PqrProductData
                data={pqr?.productData}
                onChangeFormik={(formik) => setFormikPqrProductData(formik)}
            />
            <PqrStrategicAlly
                data={pqr?.strategicAlly}
                onChangeFormik={(formik) => setFormikPqrStrategicAlly(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!pqr || !pqr.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
            <Dialog
                title="Error de integración"
                open={isOpenErrorSFCModal}
                onClose={() => setIsOpenErrorSFCModal(false)}
            >
                <Grid
                    container
                    item
                    xs={12}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            maxWidth: '500px',
                            textAlign: 'center',
                            padding: '16px',
                        }}
                    >
                        <Typography variant="h5">
                            Ocurrió un error en la integración
                            <>
                                <Typography
                                    variant="h6"
                                    style={{ marginTop: '16px' }}
                                >
                                    Resultado: {JSON.stringify(responseSmart)}
                                </Typography>
                            </>
                            {loading && <Loading />}
                        </Typography>
                    </Box>
                </Grid>
            </Dialog>
        </>
    );
};
